import { useEffect, useRef, useState } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import "leaflet-side-by-side";
import "./SplitLayerComparison.css";

const SplitLayerComparison = () => {
  const mapRef = useRef(null);
  const containerRef = useRef(null);
  const [isFullscreen, setIsFullscreen] = useState(false);

  useEffect(() => {
    if (mapRef.current) return;

    const map = L.map(containerRef.current, {
      center: [0, 0],
      zoom: 2,
      zoomControl: true,
      worldCopyJump: true,
    });

    mapRef.current = map;

    const beforeLayer = L.tileLayer(
      "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      { maxZoom: 19 }
    ).addTo(map);

    const afterLayer = L.tileLayer(
      "https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png",
      { maxZoom: 19 }
    ).addTo(map);

    L.control.sideBySide(beforeLayer, afterLayer).addTo(map);
    setTimeout(() => {
      map.invalidateSize();
    }, 100);

    return () => {
      map.remove();
      mapRef.current = null;
    };
  }, []);

  useEffect(() => {
    if (mapRef.current) {
      mapRef.current.invalidateSize();
    }
  }, [isFullscreen]);

  return (
    <div className={`split-wrapper ${isFullscreen ? "fullscreen" : ""}`}>
      <div className="map-label before">BEFORE</div>
      <div className="map-label after">AFTER</div>
      <button
        className="fullscreen-btn"
        onClick={() => setIsFullscreen(!isFullscreen)}
      >
        {isFullscreen ? "✕" : "⤢"}
      </button>
      <div ref={containerRef} className="split-map-container" />
    </div>
  );
};

export default SplitLayerComparison;
